export const locale = {
    lang: 'en',
    data: {
        BOARD_WHERE_TO_PLACE: 'From which board would you like to import cards?',
        BOARD_ACTIVITY: 'Board',
        CANCEL: 'Cancel',
        SAVE: 'Save',
    }
};
